module.exports = __webpack_public_path__ + "media/whale.870f0252.mp4";